// The quiz's eleven entries, ported verbatim in copy from after-www's
// BuildAQuote question set (app/pages/BuildAQuote/data/questions.tsx).
// The plan-scoring `scores` fields are dropped — this port carries no
// plan recommendation — and every bold span becomes a `LabelSegment`
// instead of JSX.

import type { Question } from "./types";

export const QUIZ_QUESTIONS: Question[] = [
  {
    key: "who",
    slug: "who",
    type: "singleselect",
    label: [{ text: "Who are you planning for today?" }],
    options: [
      {
        key: "myself",
        label: "Just me",
        caption:
          "Planning ahead for yourself ensures your wishes are honored. Add a second person and receive $500 off the second policy.",
      },
      {
        key: "two_people",
        label: "Two people (discounts available)",
        caption:
          "Great choice! Planning for two people together means you receive $500 off the second policy.",
      },
      {
        key: "loved_one",
        label: "A loved one",
        caption:
          "Planning for a loved one removes the burden of difficult decisions. Add yourself to receive $500 off the second policy.",
      },
    ],
  },
  {
    key: "goals",
    slug: "goals",
    type: "multiselect",
    label: [
      {
        text: "What are your goals for pre-planning your cremation? Select all that apply.",
      },
    ],
    options: [
      {
        key: "reduce_stress",
        label: "Help my loved ones",
        image: "/public/illustration-holding-hands.webp",
      },
      {
        key: "save_money",
        label: "Save money",
        image: "/public/illustration-piggy-bank.webp",
      },
      {
        key: "peace_of_mind",
        label: "My peace of mind",
        image: "/public/illustration-hand-with-heart.webp",
      },
      {
        key: "something_else",
        label: "Something else",
        image: "/public/illustration-light-bulb.webp",
      },
    ],
    minRequired: 1,
  },
  {
    key: "how_it_works",
    slug: "how-it-works",
    type: "response",
    content: {
      title: "Great, we'll get your options in minutes.",
      steps: [
        "Tell us about yourself",
        "See your recommended plan and rate",
        "Finalize your plan with a Preneed Counselor",
      ],
      testimonial: {
        quote:
          "Sincerely impressed with how thoughtful, professional, and transparent the entire experience was.",
        author: "Kim S.",
        source: "TrustPilot",
        rating: 5,
      },
    },
  },
  {
    key: "hospice",
    slug: "hospice",
    type: "yesno",
    label: [
      {
        text: "Are you or the person you're planning for currently receiving ",
      },
      { text: "hospice care", emphasize: true },
      {
        text: ", or going to be receiving hospice care within the next 6 months?",
      },
    ],
    labelForLovedOne: [
      { text: "Is your loved one currently receiving " },
      { text: "hospice care", emphasize: true },
      {
        text: ", or going to be receiving hospice care within the next 6 months?",
      },
    ],
    conditionalNext: { yes: "urgent_support", no: "travel" },
  },
  {
    key: "urgent_support",
    slug: "urgent-support",
    type: "response",
    isDeadEnd: true,
    content: {
      title: "Our Care Team can help immediately.",
      phoneKey: "hospice",
      externalLink: "https://www.after.com/passing-soon-form",
      externalLinkText: "Or continue online",
    },
  },
  {
    key: "travel",
    slug: "travel",
    type: "yesno",
    label: [
      { text: "Do you ever travel " },
      { text: "more than 75 miles from home", emphasize: true },
      { text: "?" },
    ],
    labelForLovedOne: [
      { text: "Does your loved one ever travel " },
      { text: "more than 75 miles from home", emphasize: true },
      { text: "?" },
    ],
    conditionalNext: { yes: "travel_response", no: "home" },
  },
  {
    key: "travel_response",
    slug: "travel-response",
    type: "response",
    content: {
      text: "Travel is great, but 82% of families are shocked by transport fees ($5,000+) when a death occurs away from home.\n\nOur plan eliminates this cost entirely.",
    },
    nextStep: "home",
  },
  {
    key: "home",
    slug: "home",
    type: "yesno",
    label: [
      { text: "Do you " },
      { text: "own a home", emphasize: true },
      { text: "?" },
    ],
    labelForLovedOne: [
      { text: "Does your loved one " },
      { text: "own a home", emphasize: true },
      { text: "?" },
    ],
    conditionalNext: { yes: "home_response", no: "preplanTiming" },
  },
  {
    key: "home_response",
    slug: "home-response",
    type: "response",
    content: {
      text: "Owning a home adds complexity for your family—paperwork, multiple death certificates, mortgage and taxes.\n\nAfter.com helps make this easier. Less stress. Fewer delays.",
    },
    nextStep: "preplanTiming",
  },
  {
    key: "preplanTiming",
    slug: "preplan-timing",
    type: "singleselect",
    label: [{ text: "How soon are you ready to preplan?" }],
    options: [
      { key: "right_now", label: "Right now" },
      { key: "few_weeks", label: "In the next few weeks" },
      { key: "few_months", label: "In the next few months" },
      { key: "6_plus_months", label: "6+ months from now" },
      { key: "not_sure", label: "Not sure" },
    ],
  },
];
